module.exports = __webpack_public_path__ + "img/expert.adba215c.png";